import { IFormViewForm } from 'components/FormView';

const CreditDiaryDetails: IFormViewForm = {
  id: 'CreditDiaryDetails',
  layout: {
    rows: 1,
    columns: 1
  },
  fields: [
    {
      id: '1',
      type: 'PAPER_CONTAINER',
      props: {
        name: 'notepad',
        fullWidth: true
      },
      position: {
        row: 1,
        col: 1,
        colspan: 2
      },
      children: [
        {
          id: 1,
          type: 'DIARY_DETAILS',
          props: {
            label: 'SupplierCreditDiary',
            name: 'SupplierCreditDiary',
            createApi: '/SupplierEnquiry/Supplier/<Supplier>/CreateCreditDiary',
            updateApi: '/SupplierEnquiry/Supplier/<Supplier>/CreditDiary/<DiaryId>',
            searchByIdApi: '/SupplierEnquiry/Supplier/<Supplier>/CreditDiary/<DiaryId>',
            deleteApi: '/SupplierEnquiry/Supplier/<Supplier>/CreditDiary/<DiaryId>',
            diaryType: 'CREDIT'
          }
        }
      ]
    }
  ]
};
export default CreditDiaryDetails;
